import React from "react";
import {
  CashIcon,
  MerchantIcon,
  UserActive,
  UserPending,
  ApplicationIcon,
  UploadTransactionIcon
} from "components/Icons";
import { Roles } from "common/constants";
import { FiBookOpen, FiDatabase } from "react-icons/fi";

export const RoutesLevel2 = [
  {
    label: "View Collaborators",
    icon: <UserActive width="100%" height="100%" />,
    link: "/active-collaborators",
    roles: [Roles.EnterpriseAdmin, Roles.EnterpriseDeveloper],
    isActive: true,
  },
  {
    label: "View Pending Collaborators",
    icon: <UserPending width="100%" height="100%" />,
    link: "/activation-pending-users",
    roles: [Roles.EnterpriseAdmin, Roles.EnterpriseDeveloper],
    isActive: true,
  },
  // {
  //   label: "Manage Roles",
  //   icon: <UserActive width="100%" height="100%" />,
  //   link: "/manage-roles",
  //   roles: [Roles.EnterpriseBankAdmin],
  //   isActive: true,
  // },
  {
    label: "API Credentials",
    icon: <UserActive width="100%" height="100%" />,
    link: "/api-credentials",
    roles: [Roles.EnterpriseAdmin, Roles.EnterpriseDeveloper],
    isActive: true,
  },
  {
    label: "View TPPP List",
    icon: <UserActive width="100%" height="100%" />,
    link: "/tppp-list-view",
    roles: [Roles.EnterpriseBankAdmin, Roles.EnterpriseSalesTeamMember],
    isActive: true,
    children: [
      {
        label: "View Active TPPP Users",
        icon: <UserActive width="100%" height="100%" />,
        link: "/active-tppp-users",
        roles: [Roles.EnterpriseBankAdmin, Roles.EnterpriseSalesTeamMember],
        isActive: true,
      },
    ],
  },

  {
    label: "Upload Merchant",
    icon: <MerchantIcon width="100%" height="100%" />,
    link: "/upload-merchant",
    roles: [Roles.EnterpriseAdmin, Roles.EnterpriseDeveloper],
    isActive: true,
  },
  {
    label: "View Merchant List",
    icon: <MerchantIcon width="100%" height="100%" />,
    link: "/tppp-merchants-view",
    roles: [Roles.EnterpriseAdmin, Roles.EnterpriseBankAdmin, Roles.EnterpriseSalesTeamMember, Roles.EnterpriseDeveloper],
    isActive: true,
  },
  {
    label: "View Merchant Category Code",
    icon: <MerchantIcon width="100%" height="100%" />,
    link: "/tppp-merchants-category-code-view",
    roles: [Roles.EnterpriseBankAdmin, Roles.EnterpriseSalesTeamMember],
    isActive: true,
  },
  // {
  //   label: "View Audit Activity",
  //   icon: <ApplicationIcon width="100%" height="100%" />,
  //   link: "/audit-activity",
  //   roles: [Roles.EnterpriseBankAdmin],
  //   isActive: true,
  // },
  {
    label: "Reconciliation & Settlement",
    icon: <FiBookOpen size="24px" color="black" />,
    link: "/reconciliation",
    roles: [Roles.EnterpriseAdmin, Roles.EnterpriseBankAdmin, Roles.EnterprisePaymentOperation, Roles.EnterpriseDeveloper],
    isActive: true,
    children: [
         {
        label: "Upload Transaction File",
        icon: <UploadTransactionIcon width="100%" height="100%" />,
        link: "/upload-transaction",
        roles: [Roles.EnterpriseAdmin, Roles.EnterpriseDeveloper],
        isActive: false,
      },
      {
        label: "View Reconciliation Batches",
        icon: <FiDatabase size="24px" color="black" />,
        link: "/reconciliation",
        roles: [Roles.EnterpriseAdmin, Roles.EnterpriseBankAdmin, Roles.EnterprisePaymentOperation, Roles.EnterpriseDeveloper],
        isActive: true,
      }
    ]
  },
  {
    label: "View Business Activity",
    icon: <ApplicationIcon width="100%" height="100%" />,
    link: "/business-activity",
    roles: [Roles.EnterpriseBankAdmin],
    isActive: true,
  },

  {
    label: "View Payment History",
    icon: <CashIcon width="100%" height="100%" />,
    link: "/payment-history-view",
    roles: [Roles.EnterpriseAdmin, Roles.EnterpriseBankAdmin, Roles.EnterprisePaymentOperation, Roles.EnterpriseDeveloper],
    isActive: true,
  },
   {
    label: "View Transaction History",
    icon: <CashIcon width="100%" height="100%" />,
    link: "/view-transaction-history",
    roles: [Roles.EnterpriseAdmin, Roles.EnterprisePaymentOperation, Roles.EnterpriseBankAdmin, Roles.EnterpriseDeveloper],
    isActive: true,
  },
];
